import { HttpPromiseState, StringControl, Disposers } from 'lib/helpers';
import { environment } from 'lib/environment';
import { httpClient } from 'domain/utils/httpClient';
import { action, observable, reaction, makeObservable } from 'mobx';
import Swal from 'sweetalert2';
import { AxiosResponse } from 'axios'

export interface TeacherLessonDto {
    readonly TeacherId: number;    
    readonly StudentId: number;
    readonly ClassRoomId: number;
    readonly LessonId: number;
    readonly TeacherName: string;
    readonly StudentName: string;
    readonly Title: string;
    readonly Start: string;
    readonly End: string;
    readonly Status: string;
}

export interface TeacheLessonsDto {
    readonly Lessons: TeacherLessonDto[];
}

export class TeacherLessonsSceneStore {
    private readonly disposers = new Disposers();

    @observable.ref
    LessonsState: HttpPromiseState<TeacheLessonsDto> | null;
    
    constructor() {
        makeObservable(this);
        this.LessonsState = null;
    }

    load = () => {
        this.LessonsState = this.getLessons();
    }

    private getLessons(): HttpPromiseState<TeacheLessonsDto> {
        let url = `${environment.apiServer}/teacher/lessons`;
        return httpClient.state.get<TeacheLessonsDto>(url);
    }

    // private saveWorkdays(request: TeacherWorkDayDto): Promise<AxiosResponse<TeacherWorkDayDto>> {
    //     let url = `${environment.apiServer}/teacher/work-day-schedule`;
    //     return httpClient.axios.postWithSweetAlert<TeacherWorkDayDto>(url, request);
    // }
}